<div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-items-center tw-rounded-t-5 tw-p-5 tw-pt-10 tw-relative tw-bg-left-top tw-bg-no-repeat tw-bg-cover" style="background-image: url('/assets/gamification-intro-bg.png')">
  <div class="tw-absolute tw-top-4 tw-right-4" (click)="closeBottomSheet()" (keydown.enter)="closeBottomSheet()" (keydown.space)="closeBottomSheet()">
    <img src="/assets/icons/close.svg" alt="close-icon">
  </div>
  <div class="tw-py-2 tw-px-4 tw-bg-teal-500 tw-bg-gradient-light-teal-to-teal tw-rounded-full tw-text-white tw-text-200 tw-font-bold tw-flex tw-items-center tw-gap-2 tw-mb-4 tw-font-lexend">
    <img src="/assets/icons/gift.svg" alt="gift-icon">
    <span i18n="@@unlockRewards">Unlock Rewards</span>
  </div>
  <div class="tw-w-fit tw-flex tw-flex-col tw-items-center tw-max-w-[85%] tw-font-lexend tw-mb-5">
    <h1 [ngClass]="[appConfig.Shared.Languages.TE, appConfig.Shared.Languages.KN].includes(userLanguagePreference) ? 'tw-text-[35px] tw-mb-2' : ''"
        class="tw-text-[42px] tw-font-bold tw-leading-none -tw-mb-1 -tw-tracking-[2px]" i18n="@@skinStart">#SkinStart</h1>
    <p [ngClass]="[appConfig.Shared.Languages.TE, appConfig.Shared.Languages.KN].includes(userLanguagePreference) ? 'tw-mt-2' : ''" class="tw-text-700 tw-leading-none tw-mb-4 tw-font-normal -tw-tracking-[1px]" i18n="@@challenge">Challenge</p>
    <p class="tw-text-center tw-text-gray-500 tw-leading-5 tw-font-normal tw-text-300" i18n="@@followTreatmentDaily">Follow treatment daily for 7 days to unlock a scratch card.</p>
  </div>
  <div class="tw-w-full tw-flex tw-flex-col tw-gap-2 tw-bg-white tw-rounded-4 tw-p-4 tw-pt-5 tw-mb-5">
    <p class="tw-font-body tw-text-gray-500 tw-text-200" i18n="@@howItWorks">How it works:</p>
    <div class="tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-3 tw-rounded-2.5 tw-border tw-border-gray-250 tw-p-2.5">
      <div>
        <div class="tw-w-9 tw-aspect-square tw-rounded-full tw-bg-teal-400">
          <img src="/assets/icons/paint.svg" alt="paint-icon">
        </div>
      </div>
      <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between">
        <p class="tw-font-body tw-tracking-wide tw-text-200 tw-font-bold tw-text-gray-500" i18n="@@step1">STEP 1</p>
        <p class="tw-font-lexend tw-text-200 tw-text-gray-500 tw-font-normal" i18n="@@applyProductsDaily">Apply your products daily</p>
      </div>
    </div>
    <div class="tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-3 tw-rounded-2.5 tw-border tw-border-gray-250 tw-px-2.5 tw-py-1.5">
     <div>
       <div class="tw-w-9 tw-aspect-square tw-rounded-full tw-bg-teal-400">
         <img src="/assets/icons/usage.svg" alt="usage-icon">
       </div>
     </div>
      <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between">
        <p class="tw-font-body tw-tracking-wide tw-text-200 tw-font-bold tw-text-gray-500" i18n="@@step2">STEP 2</p>
        <p class="tw-font-lexend tw-text-200 tw-text-gray-500 tw-font-normal" i18n="@@tickOnCureskinApp">Tick on Cureskin app after use</p>
        <div class="tw-font-lexend tw-text-200 tw-text-gray-500 tw-font-normal tw-flex tw-items-center tw-justify-start tw-gap-2">
          <img class="tw-w-4" src="/assets/icons/light_full.svg" alt="morning-icon">
          <p i18n="@@morning">
            Morning
          </p>
          <span class="tw-w-[1.8px] tw-h-[12px] tw-bg-gray-400 tw-mr-1"></span>
          <img class="tw-w-3" src="/assets/icons/night_full.svg" alt="night-icon">
          <p i18n="@@night">
            Night
          </p>
        </div>
      </div>
    </div>
    <div class="tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-3 tw-rounded-2.5 tw-border tw-border-gray-250 tw-p-2.5">
      <div>
        <div class="tw-w-9 tw-aspect-square tw-rounded-full tw-bg-teal-400">
          <img src="/assets/icons/reward.svg" alt="reward-icon">
        </div>
      </div>
      <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between">
        <p class="tw-font-body tw-tracking-wide tw-text-200 tw-font-bold tw-text-[#0F9D90] tw-uppercase" i18n="@@reward">REWARD</p>
        <p class="tw-font-lexend tw-text-200 tw-text-gray-500 tw-font-normal" i18n="@@getScratchCardDay7">Get your scratch card on day 7</p>
      </div>
    </div>
  </div>
  <span class="tw-border tw-w-full tw-py-3 tw-flex tw-justify-center tw-items-center tw-font-bold tw-font-lexend tw-text-500 tw-rounded-3 tw-bg-teal-600 tw-text-white tw-mb-5" i18n="@@okayCaps" (click)="closeBottomSheet()">Okay</span>
</div>
